export default __webpack_public_path__ + "static/media/cloud_evening.d22f3044.svg";